module.exports = __webpack_public_path__ + "static/media/Cutlery.2aa6f254.jpg";